<template>
  <v-form v-model="valid" @submit.prevent ref="form">
    <v-container class="px-8">
      <v-row no-gutters justify="center">
        <v-col cols="12" md="8">
          <h2 class="loginTheme--text">
            Complete seu cadastro
          </h2>
          <h4 class="mt-5 font-weight-light">
            Adicione mais algumas informações
          </h4>
        </v-col>
        <v-col cols="12" md="8" class="mt-10">
          <v-text-field
            v-model="nome"
            :rules="[v => !!v || 'Nome é obrigatório']"
            outlined
            label="Confirme seu nome"
            autocomplete="off"
            color="loginTheme"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-btn @click="submit" type="submit" class="mt-5" color="loginTheme" dark rounded block large
            >Continuar</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import authenticationService from '@/services/authentication'
import { mapActions } from 'vuex'

export default {
  data: () => ({
    valid: false
  }),
  computed: {
    nome: {
      get() {
        return this.$store.state.authentication.nome
      },
      set(value) {
        this.$store.commit('authentication/SET_NOME', value)
      }
    }
  },
  methods: {
    ...mapActions('authentication', ['register']),
    ...mapActions('user', ['authenticateUser']),
    ...mapActions('avaliacaoPsicossocial', ['setMapeamentoPsicossocial']),

    async submit() {
      if (!this.$refs.form.validate()) return

      this.$showLoading()

      try {
        const data = await this.register({
          nome: this.nome
        })

        authenticationService.setToken(data.token)

        const mapeamentoPsicossocial = {
          token: this.$route.query.token,
          encryptedIdMapeamento: this.$route.query.encryptedIdMapeamento,
          encryptedIdsEmpresas: this.$route.query.encryptedIdsEmpresas
        }

        this.authenticateUser(data.user)
        this.$setDatadogUser(data.user.id, data.user.nome, data.user.email)
        this.setMapeamentoPsicossocial(mapeamentoPsicossocial)

        const query = this.$route.query

        if (query.token || query.encryptedIdMapeamento) {
          this.$router.push({ path: '/avaliacao-psicossocial', query })
        } else {
          this.$router.push({ name: 'agendamentos' })
        }
      } catch (error) {
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.$hideLoading()
      }
    }
  }
}
</script>
